export function isRateKoVariant(variantName: string | undefined): boolean {
  return /rate\s*ko/i.test(variantName ?? "");
}
